export function isProduction(url) {
  return (
    /^(www\.)?shopkeep\.com$/.test(url) ||
    /^wordpress\.shopkeep\.com$/.test(url) ||
    /^shopkeep2018\.wpengine\.com$/.test(url) ||
    /^shopkeep-support\.lightspeedhq\.com$/.test(url)
  );
}

export function isStaging(url) {
  return (
    /^shopkeep-support-dev\.lightspeedhq\.com$/.test(url)
       ||
    /^(shopkeep2018\.staging\.)wpengine\.com$/.test(url) ||
    /^(www\.)?(uat.posrip\.|uatshopkeep[\d]?.wpengine\.)com$/.test(url) ||
    /^(www\.)?(uat.posrip\.|uatshopkeep[\d]?.staging.wpengine\.)com$/.test(
      url
    ) ||
    /^(www\.)?(uat.posrip\.|uatsk.wpengine\.)com$/.test(url) ||
    /^(www\.)?(uat.posrip\.|uatsk.staging.wpengine\.)com$/.test(url) ||
    /^(www\.)?shopkeep-staging\.com$/.test(url)
  );
}

/**
 * Local Development
 *
 * of the various test/wildcard domains that simply point to 127.0.0.1 or
 * explicitly otherwise:
 * w
 * random-name.127.0.0.1.xip.io:8000
 * admin.vcap.me:3000
 *
 * others exist such as lvh.me, lacolhost.com, localhost.tv, localtest.me
 */
export function isLocal(url) {
  return (
    /(\.xip\.io(:\d+)?|\.vcap\.me(:\d+)?)$/.test(url) ||
    /^(localhost:(8888|3000|9292))$/.test(url) ||
    /^local-shopkeep-support\.lightspeedhq\.com$/.test(url)
  );
}

